let dict = {};

export const setDict = (d) => {
  dict = d || {};
};

export function t(s, vars) {
  let out = dict[s] || s;
  if (vars) Object.keys(vars).forEach((k) => {
    out = out.split(`{${k}}`).join(vars[k]);
  });
  return out;
}

export const locale = () => document.documentElement.lang || "it";

export const LANGUAGES = [
  ["it", "Italiano"], ["en", "English"], ["fr", "Français"], ["de", "Deutsch"], ["es", "Español"],
  ["pt", "Português"], ["nl", "Nederlands"], ["pl", "Polski"], ["ro", "Română"], ["cs", "Čeština"],
  ["sk", "Slovenčina"], ["sl", "Slovenščina"], ["hr", "Hrvatski"], ["hu", "Magyar"], ["el", "Ελληνικά"],
  ["bg", "Български"], ["da", "Dansk"], ["sv", "Svenska"], ["fi", "Suomi"], ["et", "Eesti"],
  ["lv", "Latviešu"], ["lt", "Lietuvių"], ["ga", "Gaeilge"], ["mt", "Malti"], ["lb", "Lëtzebuergesch"],
  ["ca", "Català"], ["eu", "Euskara"], ["gl", "Galego"], ["cy", "Cymraeg"], ["no", "Norsk"],
  ["is", "Íslenska"], ["sr", "Српски"], ["bs", "Bosanski"], ["mk", "Македонски"], ["sq", "Shqip"],
  ["me", "Crnogorski"], ["uk", "Українська"], ["ru", "Русский"], ["be", "Беларуская"], ["tr", "Türkçe"],
  ["ka", "ქართული"], ["hy", "Հայերեն"],
];
